export function Logo({ size = 40, light = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="taoronpay-logo">
      <div
        className="flex items-center justify-center rounded-xl bg-emerald-500 text-white font-black tracking-tighter shadow-sm border border-emerald-400/30 select-none"
        style={{ width: size, height: size, fontSize: size * 0.4 }}
      >
        AP
      </div>
      <span
        className={`font-bold text-lg tracking-tight ${light ? "text-white" : "text-slate-900"}`}
      >
        ABCD&nbsp;<span className="text-emerald-500">Pay</span>
      </span>
    </div>
  );
}
